// extracted by mini-css-extract-plugin
export var checkbox = "_9o-0";
export var circle = "_9o-3";
export var horizontalContainer = "_9o-7";
export var sm = "_9o-5";
export var switch0 = "_9o-2";
export var switchDisabled = "_9o-8";
export var switchEnabled = "_9o-1";
export var textSwitchContainer = "_9o-9";
export var textSwitchOption = "_9o-a";
export var textSwitchOptionSelected = "_9o-b";
export var verticalContainer = "_9o-6";
export var xs = "_9o-4";